import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { Link, useParams } from 'react-router-dom';
import request from '../../Apis/request';
import ReactPaginate from 'react-paginate'; 
import "../Chargers/Charger.css"
import Loader from '../Chargers/Loader';
import "./Statement.css";
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';


const Statement = () => {
  document.title = "Statements";
  let Location = useLocation();
  let statementsData = Location?.state?.statementdata;
  //let userID = statementsData?._id;
  let navigate = useNavigate();
  let param = useParams();
  let userID = param.cid
  //console.log("userID", userID, "cid", cid);



  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [StatementData, setStatementData] = useState([]);
  const [filteredTransactionData, setFilteredTransactionData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [userStatuses, setUserStatuses] = useState({});
  const [statusListing, setStatusListing] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [creditTotal, setcreditTotal] = useState(0)
  const [DebitTotal, setDebitTotal] = useState(0)
  const [Wallet, setWallet] = useState(0);
  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [creditdebitStatus, setcreditdebitStatus ] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [Limit, setLimit] = useState(20);
  const [TotalCount, setTotalCount] = useState(0);
  const [showListing, setShowListing] = useState(false);
  const [extraRows, setExtraRows] = useState({});
  const [activeRow, setActiveRow] = useState(null);
  const [fruits, setfruits] = useState("Apple, Banana");
  const [Usertype, setUsertype] = useState("");

  

  const handleReset = (event) => {
    event.preventDefault();
    
    if (userID) {
      navigate(`/statements/statementListing/${userID}`);
    } else {
      navigate(`/statements/statementListing`);
    }
  };

    const handleUsertype = (e) => {
      setUsertype(e.target.value);

    }

    const toggleRow = async (index, meter) => {
      if (activeRow && activeRow.index === index) {
        // If the clicked row is already active, deactivate it
        setActiveRow(null);
        return;
      }
  
      // Activate the new row with loading state
      setActiveRow({ index, loading: true, data: null, error: null });
  
      try {
        // Fetch additional details using axios
        const response = await axios.get(
          `${BaseURL}/user/statements/order-id/${meter?.transactionId}`,
          {
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              Authorization: `Bearer ${uniqueToken}`,
            },
          }
        );
  
        // Update the activeRow with fetched data
        setActiveRow({ index, loading: false, data: response.data?.data, error: null });
      } catch (error) {
        console.error("Error fetching data:", error);
        // Update the activeRow with error state
        setActiveRow({ index, loading: false, data: null, error: true });
      }
    };
    
    

    const handleInvestClick = () => {
     setShowListing(true); // Show the listing when the button is clicked
    //  alert("hello");
    };

  const handleFromDate = (e) => {
    setFromDate(e.target.value);
}
const handleToDate = (e) => {
  setToDate(e.target.value);
}
const handlepaymentStatus = (e) => {
  setcreditdebitStatus(e.target.value);
}

const handleStatusType = (e) => {
  setSelectedStatus(e.target.value);
}


  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  };
console.log("fruits", fruits);
  const fetchTransactionData = async (currentPage) => {
    setLoading(true);
    let apiEndpoint = userID
      ? `${BaseURL}/user/statements/${userID}?page=${page}&searchText=${searchTerm}`
      : `${BaseURL}/user/statements?page=${page}&searchText=${searchTerm}`;

    // Add filters to the API endpoint if they are not empty
    if (FromDate) apiEndpoint += `&from_date=${FromDate} 00:00:00`;
    if (ToDate) apiEndpoint += `&to_date=${ToDate} 23:23:23`;
    if (creditdebitStatus) apiEndpoint += `&statement_type=${creditdebitStatus}`;
    if (selectedStatus) apiEndpoint += `&statement_status=${selectedStatus}`;
    if (Limit) apiEndpoint += `&limit=${Limit}`;
    if(Usertype) apiEndpoint += `&userType=${Usertype}`

    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      console.log("response", response);
      setStatementData(response?.data?.newData || []);
      setFilteredTransactionData(response?.data?.newData || []);
  
      setcreditTotal(response?.data?.creditTotal || 0);
      setWallet(response?.data?.walletamount || 0);
      setDebitTotal(response?.data?.debitTotal || 0);
      setLimit(response?.data?.limit);
      setTotalCount(response?.data?.totalCount);
      // setTotalCount(response.totalCount || 0);
       setPageCount(Math.ceil(response.data.totalCount / response?.data?.limit));
    } catch (error) {
      console.error("Error fetching TransactionData:", error);
    } finally {
      setLoading(false);
    }
  };

  // Effect to fetch data on page change
  useEffect(() => {
    fetchTransactionData(page);
  }, [page]);

  // Handle Filter Submit


  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1;
    setPage(selectedPage);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    fetchTransactionData(1, searchTerm);
  };
  //meter?.meter_transaction_id
  //meter?.meterTransactions?._id

  const handleSelectChange = async (meter) => {
    console.log("meterrr", meter) ;
    try {
      Swal.fire({
        title: 'Processing...',
        text: 'Please wait...',
        allowOutsideClick: false,
        showCancelButton: true, // Enables the cancel button
        cancelButtonText: 'Cancel', // Text for the cancel button
        didOpen: () => {
          Swal.showLoading();
        },
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.cancel) {
          // Handle cancel action
          Swal.fire('Cancelled', 'The operation was cancelled', 'error');
        }
      });
      //?.meterTransactions?._id, meter?.name, meter?.imei_number, meter?.email
      // Fetch transaction data
      const transactionResponse = await axios.get(`${BaseURL}/user/meter-transaction/${meter?.meter_transaction_id}`, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });
      const transactionData = transactionResponse?.data;
  
      
      
      console.log("transactionData---", transactionData);
      Swal.close();

     

      // Access meterTransactions[0].meterValueLogs (Ensure the array is accessed properly)
      const meterTransactions = transactionData?.data?.[0]?.meterTransactions || [];
      const meterValueLogs = meterTransactions?.length > 0 ? meterTransactions[0]?.meterValueLogs : [];
      const MeterData   =    transactionData?.meterData || [];
      const statementDataa = transactionData?.statementData || [];
      
   
      // Show the pop-up with transaction details

console.log("meterValueLogs", meterValueLogs);
console.log("statementDatasaaaa", statementDataa);

let totalAmount =0;
      Swal.fire({
      
        title: `
   <div style="max-width: 1300px; margin: auto; padding: 20px; background-color: #f9f9f9; font-size: 14px; border-radius: 8px; border: 1px solid #ccc; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
  <!-- Heading -->
  <h4 style="font-size: 20px; text-align: center; font-weight: bold; color: #333; margin-bottom: -900px;">Meter Transaction Logs Details</h4>

  <!-- Table -->
  <table style="width: 100%; border-collapse: collapse; margin-top: -390px;">
    <!-- Style for table -->
    <style>
      th, td {
        padding: 10px;
        text-align: left;
        border: 1px solid #ddd;
      }
      th {
        font-weight: bold;
        color: #555;
        background-color: #f1f1f1;
      }
      td {
        color: #333;
      }
    </style>

    <!-- Rows -->
    <tr>
      <th>IMEI Number</th>
      <td>${MeterData[0]?.imei_number || 'NA'}</td>
      <th>Username</th>
      <td>${MeterData[0]?.name || 'NA'}</td>
      <th>Email</th>
      <td>${MeterData[0]?.email || 'NA'}</td>
    </tr>
    <tr>
      <th>Mobile</th>
      <td>${MeterData[0]?.mobile || 'NA'}</td>
      <th>Connector Name</th>
      <td>${MeterData[0]?.meterTransactions?.connectorName || 'NA'}</td>
      <th>Connector ID</th>
      <td>${MeterData[0]?.meterTransactions?.connector_id || 'NA'}</td>
    </tr>
    <tr>
      <th>Connector Status</th>
      <td>${MeterData[0]?.meterTransactions?.connector_status || 'NA'}</td>
      <th>Before Wallet Amount</th>
      <td>${MeterData[0]?.meterTransactions?.before_wallet_amount || 'NA'}</td>
      <th>After Wallet Amount</th>
      <td>${MeterData[0]?.meterTransactions?.after_wallet_amount || 'NA'}</td>
    </tr>
    <tr>
      <th>Request Amount</th>
      <td>${MeterData[0]?.meterTransactions?.requestAmount || 'NA'}</td>
      <th>Transaction ID</th>
      <td>${MeterData[0]?.meterTransactions?.transactionId || 'NA'}</td>
      <th>Status</th>
      <td>${MeterData[0]?.meterTransactions?.status || 'NA'}</td>
    </tr>
    <tr>
      <th>Wallet Amount</th>
      <td>${MeterData[0]?.meterTransactions?.walletAmount || 'NA'}</td>
      <th>Used Amount</th>
      <td>${MeterData[0]?.meterTransactions?.usedAmount || 'NA'}</td>
      <th>Refund Amount</th>
      <td>${MeterData[0]?.meterTransactions?.refundAmount || 'NA'}</td>
    </tr>
    <tr>
      <th>Meter Start Date</th>
      <td>${MeterData[0]?.meterStartDate || 'NA'}</td>
      <th>Meter End Date</th>
      <td>${MeterData[0]?.meterEndDate || 'NA'}</td>
      <th>Invoice Number</th>
      <td>
        <a href="${MeterData[0]?.meterTransactions?.invoiceURL}" target="_blank" style="color: #333;">${MeterData[0]?.meterTransactions?.invoice_number || 'NA'}</a>
      </td>
      </tr>
      <tr>
       <th>Power Error Counter</th>
      <td>
      ${MeterData[0]?.meterTransactions?.powerErrorCounter || "N/A"}
      </td>
       <th>Current Error Counter</th>
      <td>
        ${MeterData[0]?.meterTransactions?.currentErrorCounter || "N/A"}
      </td>
       <th>Voltage Error Counter</th>
      <td>
       ${MeterData[0]?.meterTransactions?.voltageErrorCounter || "N/A"} 
      </td>
    </tr>
      <tr>
    <th>Vendor Commision</th>
    <td> ${MeterData[0]?.meterTransactions?.vendor_amount || "N/A"}  </td>
    
     <th>Total Used Amount</th>
    <td> </td>
  
    <th>Admin Collection</th>
    <td>${MeterData[0]?.meterTransactions?.admin_collection || "N/A"} </td>
      </tr>
    <tr>
     <th>Comments</th>
    <td>${MeterData[0]?.meterTransactions?.comment || "N/A"} </td>
    </tr>
  </table>
</div>
`,
width: '100%',

        
       
        html: `
<div style="max-width: 100%; overflow-x: auto;">
  <div style="font-weight: bold; margin-bottom: 10px; border: 2px solid #ccc; padding: 10px; border-radius: 5px;">
    <h4>User Wallet Details</h4>
  </div>
  <table style="table-layout: auto; width: 100%; border-collapse: collapse; font-size: 14px; text-align: left;" border="1">
    <thead>
      <tr>
        <th>Sr.No</th>
        <th>Name</th>
        <th>Mobile</th>
       <th>Booking ID</th>
       <th>Amount </th>
       <th>OrderID </th>
       <th>User Type </th>
       <th>Type</th>
       
       <th>Created At </th>


      
      </tr>
    </thead>
    <tbody>
    
      ${statementDataa?.length === 0 ? `
        <tr>
          <td colspan="10" style="text-align: center;">N/A</td>
        </tr>
      ` : statementDataa?.map((log, index) => {
        // Check if any error counter is greater than 0
      
        const amount = log?.amount_number || 0;
        if(log?.payment_status_type === "Dr" ) {
        totalAmount += amount;
        }
        else {
          totalAmount -= amount;
        }
        return `
          <tr>
          
            <td>${index + 1}</td>
            <td>${log?.name}</td>
            <td>${log?.mobile}</td>
            <td>${log?.transactionId}</td>
            <td>${log?.amount}</td>
            <td>${log?.order_id}</td>
            <td>${log?.userType}</td>
          <td>
  ${log?.payment_status_type === "Cr" ? `
    <button class="btn btn-success">Cr</button>
  ` : log?.payment_status_type === "Dr" ? `
    <button class="btn btn-danger">Dr</button>
  ` : `
    <button class="btn btn-secondary">Unknown</button>
  `}
</td>
             <td>${log?.createdAt}</td>
       
         

          
          </tr>
       
          
        `;
      }).join('')}
         <tr>
          <td><b>Admin Collection</b></td>
          <td></td>
          <td> </td>
          <td></td>
          <td>
            <b>${parseFloat(totalAmount.toFixed(2))}</b></td>
          </tr>
    </tbody>
  </table>
</div>

        <div style="max-width: 100%; overflow-x: auto;">
          <div style="font-weight: bold; margin-bottom: 10px; border: 2px solid #ccc; padding: 10px; border-radius: 5px;">
            <h4>Transaction Details</h4>
          </div>
          <table style="table-layout: auto; width: 100%; border-collapse: collapse; font-size: 14px; text-align: left;" border="1">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>Meter Start</th>
                <th>End Meter Value</th>
                <th>Consumed Power</th>
                <th>Per Unit Value</th>
                <th>Amount</th>
                <th>Request</th>
                <th>Logs</th>
                <th>Status</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              ${meterValueLogs?.length === 0 ? `
                <tr>
                  <td colspan="10" style="text-align: center;">N/A</td>
                </tr>
              ` : meterValueLogs?.map((log, index) => {
                // Check if any error counter is greater than 0
                const hasError = 
                  log?.request[0]?.powerErrorCounter > 0 ||
                  log?.request[0]?.currentErrorCounter > 0 ||
                  log?.request[0]?.voltageErrorCounter > 0;
      
                return `
                  <tr style="background-color: ${hasError ? 'yellow' : 'transparent'};">
                    <td>${index + 1}</td>
                    <td>${log?.meterStart}</td>
                    <td>${log?.endMeterValue}</td>
                    <td>${log?.consumedPower}</td>
                    <td>${log?.perUnitValue}</td>
                    <td>${log?.amount}</td>
                    <td>
                      ${log?.request && log?.request?.length > 0 ? `
                        <span style="color: red;">V|${log?.request[0]?.V || 'N/A'}</span> 
                        <span style="color: blue;">I|${log?.request[0]?.I || 'N/A'}</span> 
                        <span style="color: green;">P|${log?.request[0]?.P || 'N/A'}</span> 
                        <span style="color: purple;">B|${log?.request[0]?.B || 'N/A'}</span>
                      ` : 'No Request Data Available'}
                    </td>
                    <td>
                      <pre style="white-space: pre-wrap; word-break: break-word;">
                        ${JSON.stringify(log?.request[0], null, 2) || "N/A"}
                      </pre>
                    </td>
               <td>
  <span
    style={{
      color: log?.request[0]?.S === "true" ? "green" : "red",
    }}
  >
   ${log?.request[0]?.S === true
      ? "ON"
      : log?.request[0]?.S === false
      ? "OFF"
      : "N/A"}
  </span>
</td>
                    <td>
                      ${moment(log?.createdAt).format('DD-MMM-YYYY hh:mm:ss A')}
                    </td>
                  </tr>
                `;
              }).join('')}
            </tbody>
          </table>
        </div>
      `,
      
        showCloseButton: true,
        showConfirmButton: false
      });

    } catch (error) {
      console.error('Error fetching transaction data:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to fetch transaction details.',
      });
    }
  };
let totalamount = 0;
  console.log("filteredTransactionData", filteredTransactionData);
  console.log("creditTotal", creditTotal);
  console.log("debitTotal", DebitTotal);
  console.log("pagecount", pageCount);
  console.log("limit", Limit);
  // console.log("togleData", ToggleData);

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
              <div className="d-flex justify-content-between align-items-center">
                <h4>Statements ({TotalCount ? TotalCount : "Loading..."})</h4>
                <div className="col-md-12" style={{ marginLeft: "20px" }}>
  <button
    className="btn"
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      maxWidth: "600px", // Set a max width to prevent it from stretching too far
      padding: "10px",
      fontSize: "14px", // Adjust font size for better fit
      fontWeight: "bold",
      borderRadius: "5px",
    }}
  >
    {/* Credit Side */}
    <span
      style={{
        backgroundColor: "green",
        color: "white",
        padding: "5px 10px", // Reduced padding
        flex: 1,
        textAlign: "center",
        borderTopLeftRadius: "5px",
        borderBottomLeftRadius: "5px",
        whiteSpace: "nowrap", // Prevent text from wrapping
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      Total Credit: {creditTotal.toLocaleString()}
    </span>

    {/* Third Field */}


    {/* Debit Side */}
    <span
      style={{
        backgroundColor: "red",
        color: "white",
        padding: "5px 10px", // Reduced padding
        flex: 1,
        textAlign: "center",
        // borderTopRightRadius: "5px",
        // borderBottomRightRadius: "5px",
        whiteSpace: "nowrap", // Prevent text from wrapping
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      Total Debit: {DebitTotal.toLocaleString()}
    </span>
    <span
      style={{
        backgroundColor: "orange",
        color: "white",
        padding: "5px 10px", // Reduced padding
        flex: 1,
        borderTopRightRadius: "5px",
        borderBottomRightRadius: "5px",
        textAlign: "center",
        whiteSpace: "nowrap", // Prevent text from wrapping
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
    Wallet : {Wallet}
    </span>
  </button>
</div>


              </div>
              <hr style={{ marginTop: "5px" }} />

              <div className="row">
  <div className="col-sm-12">
    <form className="form-horizontal" style={{ marginTop: "-5px" }} onSubmit={handleSearchSubmit}>
      <div className="row px-3" style={{ display: "flex", alignItems: "center" }}>
        {/* Search input */}
        <div className="col-md-2">
          <input
            type="text"
            placeholder="Find Data Here."
            onChange={handleSearchChange}
            value={searchTerm}
            className="form-control"
            style={{ height: "38px" }}
          />
        </div>
        <div className="col-md-2">
          <input
            type="date"
            placeholder="From Date"
            onChange={handleFromDate}
            className="form-control"
            style={{ height: "38px" }}
          />
        </div>
        <div className="col-md-2">
          <input
            type="date"
            placeholder="To Date"
            onChange={handleToDate}
            className="form-control"
            style={{ height: "38px" }}
          />
        </div>
        <div className="col-md-2">
          <select
            onChange={handlepaymentStatus}
            className="form-control"
            style={{ height: "38px" }}
          >
            <option value="">Select Payment Method</option>
            <option value="Cr">Credit</option>
            <option value="Dr">Debit</option>
          </select>
        </div>
        <div className="col-md-2">
          <select
            className="form-control"
            style={{ height: "38px" }}
            onChange={handleStatusType}
          >
            <option value="">Select Statement Option</option>
            <option value="Manual" title="Admin add amount in user wallet">Manual</option>
            <option value="StopTrigger" title="User stopped manually or complete transaction by charging when amount completion">Stop Trigger</option>
            <option value="Auto" title="Complete transaction by cron job">Auto</option>
            <option value="Invest" title="When user request for transaction">Invest</option>
            <option value="CustomerAdded" title="User adds amount in his wallet">Customer Added</option>
            <option value="Withdraw" title="When user request for withdrawl">Withdrawal</option>
            <option value="CustomerInvested" title="When user Payment through bar code on charger">Customer Invested</option>
            <option value="WithdrawlRejected" title="When Admin Rejects the request of user withdrawl">Withdrawal Rejected</option>
            <option value="RfidInveset" title="When user booking through RFID Card">Rfid Invest</option>
            <option value="RfidOffer" title="Wallet amount added through RFID offer">Rfid offer</option>
            <option value="RfidCustomerAdded" title="When user amount added in wallet through Rfid QR code">Rfid CX Added</option>
            <option value="CustomerSettlement" title=""> CX Settlement</option>
          
          </select>
        </div>
        <div className="col-md-2">
          <select
            className="form-control"
            style={{ height: "38px" }}
            onChange={handleUsertype}
          >
            <option value="">Select UserType</option>
            <option value="Normal User">Normal User</option>
            <option value="Vendor">Vendor</option>
          </select>
        </div>
      </div>

      {/* Buttons - Search and Reset */}
      <div className="d-flex align-items-center" style={{ gap: "10px", marginTop: "10px" }}>
        {/* Search button */}
        <button
          type="submit"
          className="btn btn-primary"
          style={{ height: "38px", lineHeight: "20px" }}
        >
          Search
        </button>
        
        {/* Reset button */}
        <button
          type="button"  // Prevent form submit on Reset button click
          className="btn btn-primary"
          style={{ height: "38px", lineHeight: "20px" }}
          onClick={handleReset}
        >
          Reset
        </button>
      </div>

      {/* Credit and Debit totals */}
    </form>
  </div>
</div>



              <div className="card-body" style={{ marginLeft: "-19px" }}>
                {loading ? (
                  <Loader />
                ) : (
                  <>
                    <div className="table-responsive">
                      <table className="display dataTable" style={{ width: '100%', borderCollapse: 'collapse' }} id="advance-1">
                      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Mobile</th>
          <th>Usertype</th>
          <th>Transaction ID</th>
          <th>Razorpay Order ID</th>
          <th>Statement Amount</th>
          <th>Statement Type</th>
          <th>Created At</th>
          <th>Net Balance</th>
          <th>Net Balance1</th>
          <th>Actions</th>
          <th>Wallet Comment</th>
        </tr>
      </thead>
      <tbody>
        {/* Render Original Rows */}
        {filteredTransactionData?.length === 0 ? (
  <tr>
    <td colSpan="12" className="text-center">
      <h4>No Data Found</h4>
    </td>
  </tr>
) : (
  filteredTransactionData?.map((meter, index) => (
    <React.Fragment key={index}>
      <tr>
        <td>{(page - 1) * Limit + index + 1}</td>
        <td>{meter?.name}</td>
        <td>{meter?.mobile}</td>
        <td>{meter?.userType}</td>
        <td>
          <a href="#" onClick={(e) => handleSelectChange(meter)}>
            {meter?.transactionId}
          </a>
        </td>
        <td>{meter?.razorpay_order_id}</td>
        <td>{meter?.statement_amount}</td>
        <td>
          {meter?.statement_type === "Cr" ? (
            <button className="btn btn-success">Cr</button>
          ) : meter?.statement_type === "Dr" ? (
            <button className="btn btn-danger">Dr</button>
          ) : (
            <button className="btn btn-secondary">Unknown</button>
          )}
        </td>
        <td>{meter?.createdAt}</td>
        <td>{meter?.net_balance}</td>
        <td>{meter?.net_balance1}</td>
        <td>
          <button
            className="btn"
            style={{
              width: "92px",
              fontSize: "12px",
              height: "32px",
              padding: "0",
              backgroundColor: meter?.statement_status === "Manual" ? "orange" : 
                              meter?.statement_status === "StopTrigger" ? "#6f42c1" : 
                              meter?.statement_status === "Auto" ? "gray" : 
                              meter?.statement_status === "Invest" ? "green" : 
                              meter?.statement_status === "Withdraw" ? "red" : "#C6A6A6",
              color: "white",
            }}
            onClick={() => toggleRow(index, meter)}
          >
            {meter?.statement_status}
          </button>
        </td>
        <td>{meter?.wallet_comment}</td>
      </tr>

      {/* Render Extra Row Conditionally */}
      {activeRow && activeRow.index === index && (
        <tr key={`extra-${index}`} style={{ backgroundColor: "#f9f9f9" }}>
          <td colSpan="12">
            {activeRow.loading && <div>Loading...</div>}
            {activeRow.error && <div>Error fetching data.</div>}
            {activeRow.data && (
              <table
                className="display dataTable"
                style={{ width: "100%", borderCollapse: "collapse" }}
                id="advance-1"
              >
                <thead>
                  <tr>
                    <th>Booking ID</th>
                    <th>UserName</th>
                    <th>Mobile</th>
                    <th>Amount</th>
                    <th>Order ID</th>
                    <th>User Type</th>
                    <th>Type</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {activeRow.data.map((log, idx) => {
                    const amount = log?.amount_number || 0;
                    if (log?.payment_status_type === "Dr") {
                      totalamount += amount;
                    } else {
                      totalamount -= amount;
                    }
                    return (
                      <tr key={idx}>
                        <td>{log?.transactionId}</td>
                        <td>{log?.name}</td>
                        <td>{log?.mobile}</td>
                        <td>{log?.amount}</td>
                        <td>{log?.order_id}</td>
                        <td>{log?.userType}</td>
                        <td>
                          {log?.payment_status_type === "Cr" ? (
                            <button className="btn btn-success">Cr</button>
                          ) : log?.payment_status_type === "Dr" ? (
                            <button className="btn btn-danger">Dr</button>
                          ) : (
                            <button className="btn btn-secondary">Unknown</button>
                          )}
                        </td>
                        <td>{log.createdAt}</td>
                      </tr>
                    );
                  })}

                  {/* Row for displaying total */}
                  <tr>
                    <td><b>Admin Collection</b></td>
                    <td></td>
                    <td></td>
                    <td><b>{parseFloat(totalamount).toFixed(2)}</b></td>
                  </tr>
                </tbody>
              </table>
            )}
          </td>
        </tr>
      )}
    </React.Fragment>
  ))
)}

      </tbody>
                      </table>
                    </div>

                    <>
              <div className="pagination-container mt-4">
                      <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        forcePage={page - 1} 
                      />
                    </div>
               </>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statement;
